import * as React from "react";
interface props {
  className?: string;
}

const UnderMaintenanceSvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="160"
    height="160"
    className={className}
    fill="none"
    viewBox="0 0 160 160"
  >
    <path
      fill="#FF752C"
      d="m19.994 53.298 11.666.035A1.667 1.667 0 0 0 31.67 50l-11.666-.035c-2.187.03-2.205 3.29-.01 3.333M31.665 60c2.184-.036 2.197-3.29.005-3.334l-11.666-.035c-2.187.03-2.205 3.29-.01 3.333z"
    ></path>
    <path
      fill="#FF752C"
      d="M144.999 20h-130c-4.595 0-8.334 3.738-8.334 8.333.009 3.875-.005 86.528 0 93.333 0 4.595 3.739 8.334 8.334 8.334h117.726l1.819 4.136c5.833 12.022 23.341 3.697 17.71-8.413a8.23 8.23 0 0 0 1.076-4.058V28.331c0-4.595-3.738-8.333-8.333-8.333zm-135 8.333c0-2.757 2.243-5 5-5h130c2.756 0 5 2.243 5 5v10h-140zM149.63 132.336c-1.776 5.457-9.85 5.777-12.036.459l-2.255-5.129-19.582-44.545a1.67 1.67 0 0 0-1.525-.996c-11.373.263-18.898-12.719-13.075-22.43l5.175 11.098c.247.53.755.892 1.338.953l8.045.84a1.69 1.69 0 0 0 1.555-.725l4.527-6.703a1.66 1.66 0 0 0 .128-1.637l-5.173-11.098c4.747.85 8.882 3.957 10.955 8.403 2.46 5.279 1.608 11.569-2.173 16.024a1.66 1.66 0 0 0-.224 1.815l24.015 48.655a6.44 6.44 0 0 1 .304 5.013zm-20.861-54.195c9.035-11.923.331-29.356-14.652-29.281a1.68 1.68 0 0 0-1.497.775 1.67 1.67 0 0 0-.103 1.596l5.99 12.849-3.438 5.091-6.112-.638-5.992-12.848a1.664 1.664 0 0 0-2.781-.374c-9.782 11.414-2.03 29.38 12.95 30.122l18.126 41.233H14.999c-2.757 0-5-2.243-5-5v-80h140v79.487z"
    ></path>
    <path
      fill="#FF752C"
      d="M20 28.334c-3.287.057-3.285 4.945 0 5 3.286-.057 3.285-4.945 0-5M30 28.334c-3.287.057-3.285 4.945 0 5 3.286-.057 3.285-4.945 0-5M40 28.334c-3.287.057-3.285 4.945 0 5 3.286-.057 3.285-4.945 0-5M66.668 49.168c-3.517 0-6.667 1.818-8.427 4.865l-30.258 52.408c-1.759 3.047-1.759 6.684 0 9.73 1.76 3.047 4.908 4.865 8.427 4.865h60.518c3.516 0 6.666-1.818 8.426-4.865 1.759-3.046 1.759-6.683 0-9.73L75.096 54.033c-1.76-3.047-4.91-4.865-8.428-4.865m35.798 65.337a6.33 6.33 0 0 1-5.538 3.198H36.41a6.33 6.33 0 0 1-5.539-3.198 6.33 6.33 0 0 1 0-6.397L61.13 55.7a6.33 6.33 0 0 1 5.538-3.199 6.33 6.33 0 0 1 5.538 3.199l30.258 52.408a6.33 6.33 0 0 1 .002 6.397"
    ></path>
    <path
      fill="#FF752C"
      d="M66.668 97.515a3.6 3.6 0 0 0 3.585-3.369l1.472-23.533c.41-4.635-5.637-7.102-8.75-3.783a5.09 5.09 0 0 0-1.364 3.785l1.472 23.533a3.597 3.597 0 0 0 3.585 3.367M65.405 69.11c1.036-1.185 3.148-.274 2.993 1.295l-1.472 23.533c-.016.273-.501.273-.518 0l-1.472-23.532c-.03-.483.135-.943.467-1.295zM66.667 101.42c-6.984.223-6.982 10.348 0 10.57 6.983-.223 6.981-10.348 0-10.57m0 7.237c-2.565-.047-2.564-3.857 0-3.904 2.565.047 2.563 3.857 0 3.904"
    ></path>
  </svg>
);

export default UnderMaintenanceSvg;
